import React from 'react';

import { widgetsConfigurations } from 'config/widgetConfigurations/widgetsConfigurations';
import { useHistory, useParams } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import useEventWithDimensions from 'hooks/useEventWithDimensions';

import { useQueryGetReport } from 'api/queries/getReport.query';

import { ReportingBreadcrumbs } from 'components/Dashboards/Reporting/ReportingBreadCrumbs/ReportingBreadcrumbs';
import { Button } from 'components/DesignSystem/Button';
import { ConfirmWidgetPageUrlParams } from 'components/pages/ConfirmWidgetPage/ConfirmWidgetPage';
import { ReportPageUrlParams } from 'components/pages/ReportPage/ReportPage';

import classes from './ConfirmWidgetHeader.module.scss';

interface Props {
    isEditExistingWidget: boolean | undefined;
    onSave: () => void;
    isActionButtonDisabled: boolean;
}

export const ConfirmWidgetHeader = ({ isEditExistingWidget, onSave, isActionButtonDisabled }: Props) => {
    const history = useHistory();
    const { reportId, componentKey } = useParams<ReportPageUrlParams & ConfirmWidgetPageUrlParams>();
    const { data: report } = useQueryGetReport({ id: Number(reportId) });
    const { sendEventWithDimensions } = useEventWithDimensions();

    const onCancel = (): void => {
        if (!isEditExistingWidget && componentKey) {
            const componentName = widgetsConfigurations[componentKey]?.title || 'Unknown';
            sendEventWithDimensions({
                category: 'Reporting',
                action: 'Add Component Cancelled',
                label: componentName,
            });
        }
        history.replace({
            pathname: AppRoutes.buildPath(AppRoutes.DASHBOARD_REPORTING_PATH, reportId),
        });
    };

    const primaryActionBtnText = isEditExistingWidget ? 'Save changes' : 'Add to report';
    const confirmPageStateLabel = isEditExistingWidget ? 'Edit Component' : 'Add Component';

    return (
        <div className={classes.confirmWidgetHeader}>
            <div className={classes.topWrapper}>
                <ReportingBreadcrumbs
                    items={[
                        {
                            label: 'Reports',
                            to: AppRoutes.buildPath(AppRoutes.DASHBOARD_REPORTING_PATH),
                            noEllipsis: true,
                        },
                        { label: report?.name, to: AppRoutes.buildPath(AppRoutes.DASHBOARD_REPORTING_PATH, reportId) },
                        { label: confirmPageStateLabel, noEllipsis: true },
                    ]}
                />

                <div className={classes.buttonsWrapper}>
                    <Button variant={'secondary'} onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button
                        disabled={isActionButtonDisabled}
                        isLoading={isActionButtonDisabled}
                        variant={'primary'}
                        onClick={onSave}
                    >
                        {primaryActionBtnText}
                    </Button>
                </div>
            </div>
        </div>
    );
};
